exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_weather_ivE1taTWni6M4bH_i0U_y {\n  height: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n.IA_weatherIcon_3_Uwaoc-uZBFKpvQfEG67b {\n  height: 65%;\n  width: fit-content;\n}\n\n.IA_weatherTemperature_pSW250rJK_6lNdgE51S4q {\n  position: relative;\n  text-align: left;\n\n}\n\n.IA_weatherArea_2sIGX0Ei2kpkO-oOrE728P {\n  position: relative;\n  text-align: left;\n  font-weight: lighter;\n  clear: right;\n}", ""]);

// Exports
exports.locals = {
	"IA_weather": "IA_weather_ivE1taTWni6M4bH_i0U_y",
	"IA_weatherIcon": "IA_weatherIcon_3_Uwaoc-uZBFKpvQfEG67b",
	"IA_weatherTemperature": "IA_weatherTemperature_pSW250rJK_6lNdgE51S4q",
	"IA_weatherArea": "IA_weatherArea_2sIGX0Ei2kpkO-oOrE728P"
};